import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CSS } from '@dnd-kit/utilities';

// eslint-disable-next-line import/prefer-default-export
export function SortableItem({
  id,
  children,
}: {
  id: string;
  // eslint-disable-next-line no-unused-vars
  children: (props: any) => React.ReactNode;
}) {
  const {
    attributes, listeners, setNodeRef, transform, transition, isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 999 : undefined,
    marginBottom: 8,
    boxShadow: isDragging ? '0 2px 6px rgba(0,0,0,0.2)' : undefined,
    background: isDragging ? '#f7f7f7' : undefined,
    scale: isDragging ? '1.03' : undefined,
  };

  return (
    <div ref={setNodeRef} role='button' style={style}>
      {children({ attributes, listeners, isDragging })}
    </div>
  );
}
